/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import{BaseTask as s}from"./AsyncWorkerQueue.js";class t extends s{constructor(s,t,r,e,i){super(e),this.url=s,this.options=t,this.docType=r,this.key=i,this.result=null,this.status=1,this.request=null,this.abortController=null,this.resolvers=new Array,this.startTime=0}}export{t as default};
